// src/components/auth/ClaimYourProfileButton.tsx
import { useLocation, useNavigate } from "react-router-dom";
import { UserRoundCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { writeOnboarding } from "@/lib/onboarding-context";

export const ClaimYourProfileButton = ({ communitySlug, className }: { communitySlug: string; className?: string }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Button size="sm" className={`h-7 px-2.5 text-xs gap-1.5 ${className ?? ""}`}
      onClick={() => {
        writeOnboarding({
          door: "community",
          community: communitySlug,
          returnTo: location.pathname + location.search,
        });
        navigate("/login?mode=create");
      }}>
      <UserRoundCheck className="h-3.5 w-3.5" /> Claim your profile
    </Button>
  );
};
